import { AUTH_LOGOUT } from "@/store/actions/auth";

export const authorize = (err, dispatch) => {
	if (err.response?.status === 401) {
		dispatch(AUTH_LOGOUT);
	}
};
